import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Location } from "components/files/modals/MapModal";

export type ModeState = "is-dark" | "light";

export type LocationObj = {
    lat: number;
    lng: number;
    address: string;
};

export type SiteState = {
    mode: ModeState;
    location: string;
    locationLatLng: Location;
    pageScroll: boolean;
};

const initialState: SiteState = {
    mode: "light",
    location: "",
    locationLatLng: {
        lat: 0,
        lng: 0,
        address: ""
    },
    pageScroll: true
};

export const siteSlice = createSlice({
    name: "site",
    initialState,
    reducers: {
        changeMode: (state, action: PayloadAction<ModeState>) => {
            state.mode = action.payload;
        },
        setLocation: (state, action: PayloadAction<string>) => {
            state.location = action.payload;
        },
        setLocationLatLng: (state, action: PayloadAction<LocationObj>) => {
            state.locationLatLng = action.payload;
        },
        allowScroll: (state) => {
            state.pageScroll = true;
        },
        stopScroll: (state) => {
            state.pageScroll = false;
        }
    }
});

export const {
    changeMode,
    setLocation,
    setLocationLatLng,
    allowScroll,
    stopScroll
} = siteSlice.actions;

export default siteSlice.reducer;
